<template>
  <div>
    <div v-if="loading">Decrypting</div>
    <div
      v-else-if="encrypted !== null && encrypted !== ''"
      v-html="content"
    ></div>
  </div>
</template>

<script>
export default {
  name: "decrypted",
  props: ["encrypted"],
  mounted() {
    if (this.encrypted !== null && this.encrypted !== "") {
      this.decrypt();
    } else {
      this.loading = false;
    }
  },
  props: ["encrypted"],
  data() {
    return {
      loading: true,
      content: ""
    };
  },
  methods: {
    async decrypt() {
      if (!this.$store.state.notes.privateKey) {
        await this.$store.dispatch("SAVE_KEYS_FROM_LOCAL_STORAGE_TO_STATE");
      }
      console.log("text to decrypt", this.encrypted);
      const decryptedText = await this.$store.dispatch(
        "DECRYPT_TEXT",
        this.encrypted
      );
      this.content = decryptedText.data;
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
.down-arrow {
  max-width: 10px;
  top: 4px;
  position: relative;
  right: 5px;
}
</style>
